import { call, put, takeLatest } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import api from "service/apiService";
import { ApiResponse } from "types";
import { translate } from "utils";
import { ReasonCancelBooking } from "../types";
import {
	getListReasonCancelBookingAsync,
	GetListReasonCancelBookingAsyncPayload,
	setListReasonCancelBooking,
} from "./reasonCancelBooking.slice";

// Get list
function* getReasonCancelBookingSaga(action: PayloadAction<GetListReasonCancelBookingAsyncPayload>) {
	const { query } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<ReasonCancelBooking[]>>(
				"/dashboard/cancel-reason-samples",
				query,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setListReasonCancelBooking.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetReasonCancelBooking() {
	yield takeLatest(getListReasonCancelBookingAsync, getReasonCancelBookingSaga);
}

const reasonCancelBookingSaga = [
	watchGetReasonCancelBooking(),
];

export default reasonCancelBookingSaga;
